import appPlugin from '@backstage/plugin-app';
import { ApiProvider } from '@backstage/core-app-api';
import {
  coreExtensionData,
  createFrontendModule,
  ExtensionBoundary,
  type AppNode,
} from '@backstage/frontend-plugin-api';
import { CfaAppThemeProvider } from '../../theme/CfaAppThemeProvider';

const cfaAppThemeProviderExtension = appPlugin.getExtension('app').override({
  factory: (_originalFactory, { node, apis, inputs }) => {
    // plugin-app still types `node` against an older nested frontend-plugin-api.
    const appNode = node as AppNode;

    return [
      coreExtensionData.reactElement(
        <ApiProvider apis={apis}>
          <CfaAppThemeProvider>
            <ExtensionBoundary node={appNode}>
              {inputs.root.get(coreExtensionData.reactElement)}
            </ExtensionBoundary>
          </CfaAppThemeProvider>
        </ApiProvider>,
      ),
    ];
  },
});

export const cfaAppThemeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [cfaAppThemeProviderExtension],
});
